export interface ProcessUpdatedAtSource {
  created_at?: string | null;
  last_status_update_at?: string | null;
  updated_at?: string | null;
}

function cleanText(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function processUpdatedAtOf(item: ProcessUpdatedAtSource): string {
  return (
    cleanText(item.updated_at) ||
    cleanText(item.created_at)
  );
}

export function processStatusUpdatedAtOf(item: ProcessUpdatedAtSource): string {
  return cleanText(item.last_status_update_at);
}
